import { DMEData, generalSettings, registerWidget } from "dmeditor";
import MyFeed from "./MyFeed";

export default () => {
  registerWidget(
    {
      type: "mf-myfeed",
      icon: "matchfit",
      name: "My feed",
      category: "basic",
      settings: [...generalSettings],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-myfeed",
            data: {},
            children: [],
          };
        },
      },
    },
    {
      render: MyFeed,
    }
  );
};
